"use client";

export interface ErrorViewProps {
  error: Error & { digest?: string };
  onRefresh?: () => void;
}

export default function ErrorView(props: ErrorViewProps) {
  return (
    <div className="max-w-screen-sm xl:max-w-screen-xl mx-auto text-center mt-56 mb-40">
      <h1 className="text-7xl font-bold">500</h1>
      <p className="text-xl mt-8 whitespace-normal">{props.error.message}</p>
      <button
        onClick={props.onRefresh}
        className="text-brown font-bold cursor-pointer"
      >
        Refresh
      </button>
    </div>
  );
}
